export default {"src":"__ASTRO_ASSET_IMAGE__Xgi8MIDZ__","width":141,"height":169,"format":"svg"}